import { render, staticRenderFns } from "./TargetBoard.vue?vue&type=template&id=a4e9069e&scoped=true"
import script from "./TargetBoard.vue?vue&type=script&lang=js"
export * from "./TargetBoard.vue?vue&type=script&lang=js"
import style0 from "./TargetBoard.vue?vue&type=style&index=0&id=a4e9069e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e9069e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4e9069e')) {
      api.createRecord('a4e9069e', component.options)
    } else {
      api.reload('a4e9069e', component.options)
    }
    module.hot.accept("./TargetBoard.vue?vue&type=template&id=a4e9069e&scoped=true", function () {
      api.rerender('a4e9069e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/TargetBoard.vue"
export default component.exports